export const optionDetails = [
  {
    title: "Interactive Elements:",
    description: "Basic hover effects and animations (JavaScript and CSS).",
  },
  {
    title: "Responsive Design:",
    description: "Optimized for all devices (desktops, tablets, and mobile).",
  },
  {
    title: "Web Accessibility:",
    description: "WCAG A-level compliant.",
  },
  {
    title: "Performance Optimization:",
    description:
      "We ensure speed-optimized code for Frontend projects, while WordPress projects benefit from our installation and configuration of the WP Rocket plugin.",
  },
  {
    title: "SEO:",
    description:
      "We provide SEO-optimized code for Frontend projects and install and set up Yoast SEO for WordPress projects.",
  },
  {
    title: "Retina Ready:",
    description: "High-resolution display optimization.",
  },
  {
    title: "Browser Compatibility:",
    description: "Supports all modern browsers.",
  },
];
